import {
  FeatureName,
  PermissionValues,
  useCurrentAccount,
  useIsFeatureEnabled,
  useSetWorkspaceFilter,
  useWorkspaceFilter,
} from '@gripp/shared-logic';
import {
  countFilters,
  FilterHeaders,
  SlideAction,
  useSlideLayout,
  ViewMode,
  WorkspacesSearchInput,
} from '@gripp/shared-ui';
import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { AddButton } from '../../shared/components/addButton/addButton';

export const WorkspacesFilters = () => {
  const navigate = useNavigate();
  const { currentViewMode, onSlideChange } = useSlideLayout();
  const { account } = useCurrentAccount();
  const isCropCircleEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );

  const { data: workspaceFilter } = useWorkspaceFilter();
  const { mutateAsync: setWorkspaceFilter } = useSetWorkspaceFilter();
  const filterCount = countFilters(workspaceFilter);

  const canAddWorkspace = useMemo(
    () =>
      !!(account && account.hasPermission(PermissionValues.workspace.create)),
    [account]
  );

  const onFilterNavigate = async () => {
    if (currentViewMode === ViewMode.SINGLE) {
      await onSlideChange(SlideAction.DUAL);
    }
    navigate('/workspaces/filters');
  };

  const onNewWorkspaceNavigate = async () => {
    if (currentViewMode === ViewMode.SINGLE) {
      await onSlideChange(SlideAction.DUAL);
    }
    navigate('/workspaces/new');
  };

  return (
    <View style={styles.filtersContainer}>
      <FilterHeaders
        currentSearchKeyword={workspaceFilter?.keyword}
        searchComponent={<WorkspacesSearchInput />}
        onFilterPress={onFilterNavigate}
        onSearchClose={() =>
          setWorkspaceFilter({ ...workspaceFilter, keyword: '' })
        }
        filterCount={filterCount}
        Routes={{}}
      />

      {isCropCircleEnabled && canAddWorkspace && (
        <AddButton
          onPress={onNewWorkspaceNavigate}
          accessibilityLabel="Add workspace"
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 12,
  },
});
